<template>
    <div class="pricing-page" v-if="loadTranslation">
        <PricingBackdrop />
        <SiteHeader :trial="isUrlPlansTrial" />
        <div class="shell">
            <main id="main">
                <section class="hero wrap" aria-labelledby="hero-title">
                    <h1 class="hero__title display" id="hero-title">
                        {{ translateWord('Tudo o que o seu negócio precisa.') }}<br>
                        {{ translateWord('Uma plataforma poderosa.') }}
                    </h1>
                    <template v-if="planTypeView != 'trial'">
                        <p class="hero__sub copy">{{ translateWord('Já usa WordPress? Hospede seu site com a Builderall e aproveite todos os benefícios da nossa plataforma tudo-em-um.') }}</p>
                        <a class="learn" :href="wordpressHref()">
                            <span>{{ translateWord('Saiba mais') }}</span>
                            <svg aria-hidden="true" viewBox="0 0 14 14">
                                <path d="M13.9075 6.77566L10.7257 3.59389C10.6114 3.46043 10.4106 3.44487 10.2771 3.55919C10.1436 3.67348 10.1281 3.87435 10.2424 4.00781C10.2531 4.02025 10.2647 4.03187 10.2771 4.04251L12.9148 6.68338H0.318166C0.142458 6.68338 0 6.82584 0 7.00157C0 7.17731 0.142458 7.31974 0.318166 7.31974H12.9148L10.2771 9.95741C10.1436 10.0717 10.1281 10.2726 10.2424 10.406C10.3567 10.5395 10.5576 10.555 10.691 10.4407C10.7035 10.4301 10.7151 10.4185 10.7257 10.406L13.9075 7.22425C14.0308 7.1002 14.0308 6.89977 13.9075 6.77566Z"/>
                            </svg>
                        </a>
                    </template>
                </section>

                <section class="wrap" aria-labelledby="plans-title">
                    <h2 class="visually-hidden" id="plans-title">{{ translateWord('Planos') }}</h2>

                    <div class="billing">
                        <div class="billing__switch">
                            <div class="toggle" role="group" :aria-label="translateWord('Período de cobrança')">
                                <button type="button" :aria-pressed="recurrencePeriod == 'MONTHLY' ? 'true' : 'false'" @click="changePeriodCharge('MONTHLY')">{{ translateWord('Mensal') }}</button>
                                <button type="button" :aria-pressed="recurrencePeriod == 'YEARLY' ? 'true' : 'false'" @click="changePeriodCharge('YEARLY')">{{ translateWord('Anual') }}</button>
                            </div>
                            <p v-if="recurrencePeriod == 'MONTHLY'" class="billing__note">{{ translateWord('Cobrança mensal. Preços em {0}.', [billingCurrency]) }}</p>
                            <p v-else class="billing__note" v-html="translateWord('<strong>Melhor custo-benefício: ganhe 3 meses grátis</strong> no plano anual')"></p>
                        </div>
                        <div class="includes">
                            <h2>{{ translateWord('Todos os planos incluem') }}</h2>
                            <ul>
                                <li>
                                    <svg aria-hidden="true" viewBox="0 0 12 12"><path d="M11.625 6C11.625 6.48 11.0353 6.87562 10.9172 7.31812C10.7953 7.77562 11.1038 8.41313 10.8722 8.81344C10.6369 9.22031 9.92906 9.26906 9.59906 9.59906C9.26906 9.92906 9.22031 10.6369 8.81344 10.8722C8.41313 11.1038 7.77562 10.7953 7.31812 10.9172C6.87562 11.0353 6.48 11.625 6 11.625C5.52 11.625 5.12437 11.0353 4.68187 10.9172C4.22437 10.7953 3.58688 11.1038 3.18656 10.8722C2.77969 10.6369 2.73094 9.92906 2.40094 9.59906C2.07094 9.26906 1.36312 9.22031 1.12781 8.81344C0.89625 8.41313 1.20469 7.77562 1.08281 7.31812C0.964688 6.87562 0.375 6.48 0.375 6C0.375 5.52 0.964688 5.12437 1.08281 4.68187C1.20469 4.22437 0.89625 3.58688 1.12781 3.18656C1.36312 2.77969 2.07094 2.73094 2.40094 2.40094C2.73094 2.07094 2.77969 1.36312 3.18656 1.12781C3.58688 0.89625 4.22437 1.20469 4.68187 1.08281C5.12437 0.964688 5.52 0.375 6 0.375C6.48 0.375 6.87562 0.964688 7.31812 1.08281C7.77562 1.20469 8.41313 0.89625 8.81344 1.12781C9.22031 1.36312 9.26906 2.07094 9.59906 2.40094C9.92906 2.73094 10.6369 2.77969 10.8722 3.18656C11.1038 3.58688 10.7953 4.22437 10.9172 4.68187C11.0353 5.12437 11.625 5.52 11.625 6Z" fill="#2568EF"/><path d="M7.62508 4.32328L5.48383 6.46453L4.37383 5.35547C4.13289 5.11453 3.74195 5.11453 3.50102 5.35547C3.26008 5.59641 3.26008 5.98734 3.50102 6.22828L5.0582 7.78547C5.29258 8.01984 5.6732 8.01984 5.90758 7.78547L8.49695 5.19609C8.73789 4.95516 8.73789 4.56422 8.49695 4.32328C8.25602 4.08234 7.86602 4.08234 7.62508 4.32328Z" fill="#FFFCEE"/></svg>
                                    <span>{{ translateWord('Hospedagem segura de sites') }}</span>
                                </li>
                                <li>
                                    <svg aria-hidden="true" viewBox="0 0 12 12"><path d="M11.625 6C11.625 6.48 11.0353 6.87562 10.9172 7.31812C10.7953 7.77562 11.1038 8.41313 10.8722 8.81344C10.6369 9.22031 9.92906 9.26906 9.59906 9.59906C9.26906 9.92906 9.22031 10.6369 8.81344 10.8722C8.41313 11.1038 7.77562 10.7953 7.31812 10.9172C6.87562 11.0353 6.48 11.625 6 11.625C5.52 11.625 5.12437 11.0353 4.68187 10.9172C4.22437 10.7953 3.58688 11.1038 3.18656 10.8722C2.77969 10.6369 2.73094 9.92906 2.40094 9.59906C2.07094 9.26906 1.36312 9.22031 1.12781 8.81344C0.89625 8.41313 1.20469 7.77562 1.08281 7.31812C0.964688 6.87562 0.375 6.48 0.375 6C0.375 5.52 0.964688 5.12437 1.08281 4.68187C1.20469 4.22437 0.89625 3.58688 1.12781 3.18656C1.36312 2.77969 2.07094 2.73094 2.40094 2.40094C2.73094 2.07094 2.77969 1.36312 3.18656 1.12781C3.58688 0.89625 4.22437 1.20469 4.68187 1.08281C5.12437 0.964688 5.52 0.375 6 0.375C6.48 0.375 6.87562 0.964688 7.31812 1.08281C7.77562 1.20469 8.41313 0.89625 8.81344 1.12781C9.22031 1.36312 9.26906 2.07094 9.59906 2.40094C9.92906 2.73094 10.6369 2.77969 10.8722 3.18656C11.1038 3.58688 10.7953 4.22437 10.9172 4.68187C11.0353 5.12437 11.625 5.52 11.625 6Z" fill="#2568EF"/><path d="M7.62508 4.32328L5.48383 6.46453L4.37383 5.35547C4.13289 5.11453 3.74195 5.11453 3.50102 5.35547C3.26008 5.59641 3.26008 5.98734 3.50102 6.22828L5.0582 7.78547C5.29258 8.01984 5.6732 8.01984 5.90758 7.78547L8.49695 5.19609C8.73789 4.95516 8.73789 4.56422 8.49695 4.32328C8.25602 4.08234 7.86602 4.08234 7.62508 4.32328Z" fill="#FFFCEE"/></svg>
                                    <span>{{ translateWord('Garantia de reembolso de 30 dias') }}</span>
                                </li>
                                <li>
                                    <svg aria-hidden="true" viewBox="0 0 12 12"><path d="M11.625 6C11.625 6.48 11.0353 6.87562 10.9172 7.31812C10.7953 7.77562 11.1038 8.41313 10.8722 8.81344C10.6369 9.22031 9.92906 9.26906 9.59906 9.59906C9.26906 9.92906 9.22031 10.6369 8.81344 10.8722C8.41313 11.1038 7.77562 10.7953 7.31812 10.9172C6.87562 11.0353 6.48 11.625 6 11.625C5.52 11.625 5.12437 11.0353 4.68187 10.9172C4.22437 10.7953 3.58688 11.1038 3.18656 10.8722C2.77969 10.6369 2.73094 9.92906 2.40094 9.59906C2.07094 9.26906 1.36312 9.22031 1.12781 8.81344C0.89625 8.41313 1.20469 7.77562 1.08281 7.31812C0.964688 6.87562 0.375 6.48 0.375 6C0.375 5.52 0.964688 5.12437 1.08281 4.68187C1.20469 4.22437 0.89625 3.58688 1.12781 3.18656C1.36312 2.77969 2.07094 2.73094 2.40094 2.40094C2.73094 2.07094 2.77969 1.36312 3.18656 1.12781C3.58688 0.89625 4.22437 1.20469 4.68187 1.08281C5.12437 0.964688 5.52 0.375 6 0.375C6.48 0.375 6.87562 0.964688 7.31812 1.08281C7.77562 1.20469 8.41313 0.89625 8.81344 1.12781C9.22031 1.36312 9.26906 2.07094 9.59906 2.40094C9.92906 2.73094 10.6369 2.77969 10.8722 3.18656C11.1038 3.58688 10.7953 4.22437 10.9172 4.68187C11.0353 5.12437 11.625 5.52 11.625 6Z" fill="#2568EF"/><path d="M7.62508 4.32328L5.48383 6.46453L4.37383 5.35547C4.13289 5.11453 3.74195 5.11453 3.50102 5.35547C3.26008 5.59641 3.26008 5.98734 3.50102 6.22828L5.0582 7.78547C5.29258 8.01984 5.6732 8.01984 5.90758 7.78547L8.49695 5.19609C8.73789 4.95516 8.73789 4.56422 8.49695 4.32328C8.25602 4.08234 7.86602 4.08234 7.62508 4.32328Z" fill="#FFFCEE"/></svg>
                                    <span>{{ translateWord('Email profissional @seudominio.com') }}</span>
                                </li>
                                <li>
                                    <svg aria-hidden="true" viewBox="0 0 12 12"><path d="M11.625 6C11.625 6.48 11.0353 6.87562 10.9172 7.31812C10.7953 7.77562 11.1038 8.41313 10.8722 8.81344C10.6369 9.22031 9.92906 9.26906 9.59906 9.59906C9.26906 9.92906 9.22031 10.6369 8.81344 10.8722C8.41313 11.1038 7.77562 10.7953 7.31812 10.9172C6.87562 11.0353 6.48 11.625 6 11.625C5.52 11.625 5.12437 11.0353 4.68187 10.9172C4.22437 10.7953 3.58688 11.1038 3.18656 10.8722C2.77969 10.6369 2.73094 9.92906 2.40094 9.59906C2.07094 9.26906 1.36312 9.22031 1.12781 8.81344C0.89625 8.41313 1.20469 7.77562 1.08281 7.31812C0.964688 6.87562 0.375 6.48 0.375 6C0.375 5.52 0.964688 5.12437 1.08281 4.68187C1.20469 4.22437 0.89625 3.58688 1.12781 3.18656C1.36312 2.77969 2.07094 2.73094 2.40094 2.40094C2.73094 2.07094 2.77969 1.36312 3.18656 1.12781C3.58688 0.89625 4.22437 1.20469 4.68187 1.08281C5.12437 0.964688 5.52 0.375 6 0.375C6.48 0.375 6.87562 0.964688 7.31812 1.08281C7.77562 1.20469 8.41313 0.89625 8.81344 1.12781C9.22031 1.36312 9.26906 2.07094 9.59906 2.40094C9.92906 2.73094 10.6369 2.77969 10.8722 3.18656C11.1038 3.58688 10.7953 4.22437 10.9172 4.68187C11.0353 5.12437 11.625 5.52 11.625 6Z" fill="#2568EF"/><path d="M7.62508 4.32328L5.48383 6.46453L4.37383 5.35547C4.13289 5.11453 3.74195 5.11453 3.50102 5.35547C3.26008 5.59641 3.26008 5.98734 3.50102 6.22828L5.0582 7.78547C5.29258 8.01984 5.6732 8.01984 5.90758 7.78547L8.49695 5.19609C8.73789 4.95516 8.73789 4.56422 8.49695 4.32328C8.25602 4.08234 7.86602 4.08234 7.62508 4.32328Z" fill="#FFFCEE"/></svg>
                                    <span>{{ translateWord('Ferramentas de vendas de pacotes Supercharge') }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <p v-if="planTypeView == 'wp'" class="wp-note">
                        <span>{{ translateWord('Você está vendo os planos de hospedagem WordPress.') }}</span>
                        <a :href="allPlansHref()">{{ translateWord('Ver todos os planos') }}</a>
                    </p>

                    <ul id="plans-grid" class="plans" :class="{ 'is-3': planTypeView == 'wp', 'is-skeleton': loading.plans }" :style="priceFit">
                        <li v-for="plan in plansFilter" :key="plan.slug">
                            <article class="plan">
                                <p v-if="plan.recommended" class="plan__flag">{{ translateWord('MAIS POPULAR') }}</p>
                                <h3 class="plan__name">{{ plan.title }}</h3>
                                <p class="plan__desc">{{ plan.subTitle }}</p>
                                <p class="plan__price">
                                    <span>{{ displaySymbol(plan) }}</span><span class="plan__amount">{{ amountSplit(plan.price) }}.{{ amountSplit(plan.price, true) }}</span><span>{{ translateWord('/mes') }}</span>
                                </p>
                                <a class="pp-btn" :href="planCheckoutHref(plan)" :aria-disabled="loading.plans ? 'true' : null" @click="onPlanCta">{{ isUrlPlansTrial ? translateWord('TESTE GRATUITO DE 14 DIAS') : translateWord('ASSINAR AGORA') }}</a>
                                <div class="plan__body">
                                    <div class="plan__group">
                                        <h4 class="plan__label plan__label--blue">{{ translateWord('Ferramentas de Negócio') }}</h4>
                                        <ul>
                                            <li v-for="item in getCardFeatures(plan).toolkit" :key="item.label">
                                                <span v-if="item.value" class="qty" :class="'qty--' + (item.color || 'blue')">{{ item.value }}</span>
                                                <span>{{ item.label }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="plan__group">
                                        <h4 class="plan__label plan__label--orange">{{ translateWord('Construtor de sites') }}</h4>
                                        <ul>
                                            <li v-for="item in getCardFeatures(plan).builder" :key="item.label">
                                                <span v-if="item.value" class="qty" :class="'qty--' + (item.color || 'orange')">{{ item.value }}</span>
                                                <span>{{ item.label }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div v-if="getCardFeatures(plan).email.length" class="plan__group">
                                        <h4 class="plan__label plan__label--green">{{ translateWord('Email Marketing') }}</h4>
                                        <ul>
                                            <li v-for="item in getCardFeatures(plan).email" :key="item.label">
                                                <span v-if="item.value" class="qty" :class="'qty--' + (item.color || 'green')">{{ item.value }}</span>
                                                <span>{{ item.label }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <p v-if="getCardFeatures(plan).email.length" class="plan__extra">- {{ translateWord('Adicional @ $10 por 5.000') }}</p>
                            </article>
                        </li>
                    </ul>
                    <div class="trust" :class="{ 'trust--brl': showBrlPay }">
                        <div>
                            <h2>{{ translateWord('Aceitamos as principais formas de pagamento') }}</h2>
                            <ul class="pay">
                                <li><img :src="require('@/assets/card-brands/news/visa.png')" alt="Visa" width="67" height="50"></li>
                                <li><img :src="require('@/assets/card-brands/news/paypal.png')" alt="PayPal" width="67" height="50"></li>
                                <li><img :src="require('@/assets/card-brands/news/master.png')" alt="Mastercard" width="67" height="50"></li>
                                <li><img :src="require('@/assets/card-brands/news/google-pay.png')" alt="Google Pay" width="67" height="50"></li>
                                <li><img :src="require('@/assets/card-brands/news/apple-pay.png')" alt="Apple Pay" width="67" height="50"></li>
                                <li><img :src="require('@/assets/card-brands/news/amex.png')" alt="American Express" width="67" height="50"></li>
                                <li><img :src="require('@/assets/card-brands/news/amazon-pay.png')" alt="Amazon Pay" width="67" height="50"></li>
                                <li v-if="showBrlPay"><img :src="require('@/assets/card-brands/news/boleto.png')" alt="Boleto" width="67" height="50"></li>
                                <li v-if="showBrlPay"><img :src="require('@/assets/card-brands/news/pix.png')" alt="Pix" width="67" height="50"></li>
                            </ul>
                        </div>
                    <ul class="badges">
                        <li class="badge"><svg viewBox="0 0 63 63" aria-hidden="true" focusable="false"><circle cx="31.5" cy="31.5" r="31" fill="#E7F0FF" stroke="#2568EF"/><svg x="15.12" y="15.12" width="31.66" height="34.41" viewBox="0 0 32 35" fill="none"><path d="M31.6583 8.72394C31.6423 7.58892 30.7785 6.62368 29.6495 6.4776C23.1938 5.64356 18.705 2.01137 17.0744 0.48827C16.3765 -0.162757 15.2839 -0.162757 14.5872 0.48827C12.9566 2.01137 8.46662 5.64356 2.01149 6.4776C0.882526 6.62368 0.0192684 7.58947 0.00328219 8.72394C-0.0667266 13.8103 0.852759 30.6929 15.6301 34.3868C15.6963 34.4034 15.7635 34.4116 15.8308 34.4116C15.898 34.4116 15.9653 34.4034 16.0314 34.3868C30.8088 30.6929 31.7283 13.8103 31.6583 8.72394ZM15.8308 32.7314C2.42492 29.2271 1.59143 13.5022 1.65703 8.7471C1.66144 8.42958 1.90509 8.15946 2.22317 8.11812C9.15458 7.22234 13.9681 3.32941 15.7156 1.69716C15.7481 1.66684 15.7894 1.65251 15.8308 1.65251C15.8721 1.65251 15.9135 1.66739 15.9454 1.69771C17.6929 3.32996 22.5059 7.22234 29.4373 8.11867C29.7559 8.16002 30.0001 8.43013 30.004 8.74765C30.0701 13.5022 29.2366 29.2271 15.8308 32.7314Z" fill="#2568EF"/></svg><svg x="22.09" y="28.24" width="5.16" height="8.17" viewBox="0 0 6 9" fill="none"><path d="M4.62444 4.23084C4.46568 4.0583 4.28487 3.90947 4.08146 3.78543C3.87804 3.6614 3.67077 3.5506 3.45909 3.45303C3.24797 3.35546 3.04014 3.26285 2.83728 3.17575C2.63387 3.0881 2.45196 2.99439 2.291 2.89517C2.13003 2.79594 2.00214 2.68183 1.90677 2.55339C1.81141 2.42495 1.76345 2.27391 1.76345 2.09861C1.76345 1.98064 1.78495 1.86874 1.82739 1.76345C1.87039 1.65761 1.93544 1.5672 2.02254 1.49168C2.10963 1.41616 2.21878 1.35718 2.34888 1.31473C2.47897 1.27173 2.63167 1.25079 2.80641 1.25079C3.03022 1.25079 3.23529 1.27835 3.42271 1.33292C3.61014 1.3875 3.77441 1.44869 3.91663 1.51594C4.05885 1.58319 4.17903 1.64493 4.2766 1.70171C4.37417 1.75904 4.44528 1.78715 4.48993 1.78715C4.53458 1.78715 4.57041 1.77503 4.59687 1.75077C4.62333 1.72652 4.64318 1.68793 4.65751 1.63501C4.67184 1.58209 4.68177 1.51484 4.68838 1.4338C4.69445 1.35222 4.69775 1.25244 4.69775 1.13502C4.69775 1.02918 4.69555 0.940984 4.69169 0.869873C4.68783 0.798762 4.68011 0.739778 4.67019 0.692921C4.65972 0.646065 4.64759 0.60858 4.63381 0.579915C4.61948 0.551801 4.59191 0.517073 4.55167 0.47628C4.51088 0.435488 4.42764 0.384772 4.3014 0.323584C4.17517 0.262946 4.03074 0.207821 3.86812 0.15876C3.7055 0.11025 3.53076 0.0716631 3.34333 0.0429981C3.15591 0.0143331 2.96903 0 2.78216 0C2.41999 0 2.07766 0.0468561 1.75408 0.140017C1.43105 0.23373 1.14991 0.37485 0.912319 0.56448C0.67473 0.753559 0.485652 0.991148 0.345083 1.27835C0.204515 1.565 0.134506 1.8974 0.134506 2.27556C0.134506 2.60521 0.183015 2.888 0.281138 3.12393C0.378709 3.35987 0.505496 3.56438 0.662051 3.73692C0.818606 3.90947 0.99666 4.0583 1.19566 4.18233C1.39521 4.30637 1.60028 4.41717 1.81196 4.51474C2.02309 4.61231 2.2287 4.70492 2.42826 4.79202C2.62726 4.87967 2.80531 4.97338 2.96187 5.0726C3.11842 5.17183 3.24576 5.28594 3.34333 5.41438C3.4409 5.54227 3.48996 5.69607 3.48996 5.87467C3.48996 6.02957 3.4613 6.16959 3.40452 6.29528C3.34774 6.42151 3.26561 6.52735 3.15756 6.6128C3.04952 6.69769 2.91832 6.76384 2.76397 6.81069C2.60907 6.85755 2.43432 6.8807 2.23918 6.8807C1.94205 6.8807 1.68076 6.84708 1.4553 6.77982C1.22929 6.71312 1.03525 6.6387 0.872629 6.55767C0.71001 6.47664 0.576607 6.40222 0.472972 6.33497C0.369337 6.26771 0.288855 6.23409 0.231525 6.23409C0.190733 6.23409 0.155453 6.24566 0.125134 6.26771C0.0942644 6.29031 0.0700087 6.3278 0.0518174 6.38072C0.0336262 6.43364 0.0198452 6.5031 0.0121277 6.58799C0.00385892 6.67343 0 6.77982 0 6.90551C0 7.09238 0.0110255 7.23626 0.0336267 7.33548C0.0556767 7.43526 0.0931617 7.51133 0.146633 7.56425C0.199553 7.61717 0.285548 7.67781 0.40572 7.74727C0.525893 7.81617 0.675281 7.88233 0.853886 7.94517C1.03249 8.00801 1.23921 8.06203 1.47349 8.10668C1.70722 8.15133 1.96025 8.17393 2.23311 8.17393C2.63553 8.17393 3.01424 8.12102 3.36759 8.01518C3.72149 7.90989 4.03074 7.75168 4.29534 7.54275C4.55939 7.33328 4.76886 7.07199 4.92377 6.75888C5.07867 6.44577 5.15584 6.08139 5.15584 5.66685C5.15584 5.34933 5.10678 5.07426 5.00921 4.83997C4.91109 4.6068 4.78265 4.40338 4.62444 4.23084Z" fill="#2568EF"/></svg><svg x="28.54" y="28.24" width="5.16" height="8.17" viewBox="0 0 6 9" fill="none"><path d="M4.62499 4.23084C4.46568 4.0583 4.28487 3.90947 4.08145 3.78543C3.87859 3.6614 3.67133 3.5506 3.45909 3.45303C3.24797 3.35546 3.04014 3.26285 2.83728 3.17575C2.63387 3.0881 2.45196 2.99439 2.29099 2.89517C2.13003 2.79594 2.00214 2.68183 1.90677 2.55339C1.81141 2.42495 1.76345 2.27391 1.76345 2.09861C1.76345 1.98064 1.78495 1.86874 1.82739 1.76345C1.87039 1.65761 1.93544 1.5672 2.02254 1.49168C2.10963 1.41616 2.21878 1.35718 2.34888 1.31473C2.47897 1.27173 2.63167 1.25079 2.80641 1.25079C3.03022 1.25079 3.23529 1.27835 3.42216 1.33292C3.60959 1.38805 3.77441 1.44869 3.91608 1.51594C4.05885 1.58319 4.17903 1.64493 4.2766 1.70171C4.37362 1.75904 4.44528 1.78715 4.48993 1.78715C4.53458 1.78715 4.57041 1.77503 4.59632 1.75077C4.62333 1.72652 4.64318 1.68793 4.65751 1.63501C4.67129 1.58209 4.68177 1.51484 4.68783 1.4338C4.69445 1.35222 4.69775 1.25244 4.69775 1.13502C4.69775 1.02918 4.69555 0.940984 4.69114 0.869873C4.68673 0.798762 4.67956 0.739778 4.66964 0.692921C4.65972 0.646065 4.64704 0.60858 4.63326 0.579915C4.61947 0.551801 4.59191 0.517073 4.55167 0.47628C4.51088 0.435488 4.42709 0.384772 4.30085 0.323584C4.17462 0.262946 4.03074 0.207821 3.86812 0.15876C3.7055 0.11025 3.53076 0.0716631 3.34388 0.0429981C3.15646 0.0143331 2.96903 0 2.78216 0C2.41999 0 2.07766 0.0468561 1.75408 0.140017C1.43105 0.23373 1.14991 0.37485 0.912319 0.56448C0.67473 0.753559 0.485652 0.991148 0.345083 1.27835C0.204514 1.565 0.134506 1.8974 0.134506 2.27556C0.134506 2.60521 0.183015 2.888 0.281138 3.12393C0.378709 3.35987 0.505496 3.56438 0.662051 3.73692C0.818606 3.90947 0.99666 4.0583 1.19566 4.18233C1.39521 4.30637 1.60028 4.41717 1.81196 4.51474C2.02309 4.61231 2.2287 4.70492 2.42826 4.79202C2.62726 4.87967 2.80531 4.97338 2.96187 5.0726C3.11842 5.17183 3.24576 5.28594 3.34333 5.41438C3.44035 5.54227 3.48996 5.69607 3.48996 5.87467C3.48996 6.02957 3.46075 6.16959 3.40397 6.29528C3.34719 6.42151 3.26505 6.52735 3.15756 6.6128C3.05007 6.69769 2.91832 6.76384 2.76397 6.81069C2.60907 6.85755 2.43432 6.8807 2.23918 6.8807C1.94205 6.8807 1.68076 6.84708 1.4553 6.77982C1.22929 6.71312 1.03525 6.6387 0.872629 6.55767C0.71001 6.47664 0.576607 6.40222 0.472972 6.33497C0.369337 6.26771 0.288855 6.23409 0.231525 6.23409C0.190733 6.23409 0.155453 6.24566 0.125134 6.26771C0.0942644 6.29031 0.0700087 6.3278 0.0518174 6.38072C0.0336262 6.43364 0.0198457 6.5031 0.0121282 6.58799C0.00385945 6.67343 0 6.77982 0 6.90551C0 7.09238 0.0110255 7.23626 0.0336267 7.33548C0.0556767 7.43526 0.0931617 7.51133 0.146633 7.56425C0.199553 7.61717 0.285548 7.67781 0.40572 7.74727C0.525892 7.81617 0.675281 7.88233 0.853886 7.94517C1.03249 8.00801 1.23921 8.06203 1.47349 8.10668C1.70722 8.15133 1.96025 8.17393 2.23311 8.17393C2.63553 8.17393 3.01424 8.12102 3.36759 8.01518C3.72204 7.90989 4.03074 7.75168 4.29589 7.54275C4.55994 7.33328 4.76941 7.07199 4.92376 6.75888C5.07867 6.44577 5.15639 6.08139 5.15639 5.66685C5.15639 5.34933 5.10678 5.07426 5.00976 4.83997C4.91164 4.6068 4.78375 4.40338 4.62499 4.23084Z" fill="#2568EF"/></svg><svg x="35.48" y="28.34" width="4.34" height="7.93" viewBox="0 0 5 8" fill="none"><path d="M4.27549 6.75061C4.2551 6.69989 4.22974 6.66351 4.19942 6.64091C4.16855 6.61886 4.13327 6.60728 4.09248 6.60728H1.60965V0.256331C1.60965 0.215539 1.59642 0.179157 1.56996 0.146633C1.5435 0.114109 1.49995 0.0881999 1.43931 0.0672524C1.37813 0.0468561 1.29654 0.0308705 1.19511 0.0181918C1.09313 0.00606427 0.963585 0 0.804825 0C0.650475 0 0.520931 0.00606427 0.417296 0.0181918C0.313661 0.0303193 0.231524 0.0468561 0.170335 0.0672524C0.109698 0.0876486 0.0661492 0.114109 0.0396892 0.146633C0.012678 0.179157 0 0.215539 0 0.256331V7.42479C0 7.60339 0.045752 7.73294 0.137259 7.81176C0.228767 7.8917 0.341774 7.93083 0.475728 7.93083H4.09358C4.13437 7.93083 4.17021 7.91926 4.20052 7.89445C4.23084 7.8702 4.2562 7.83051 4.2766 7.77538C4.29699 7.72026 4.31188 7.65135 4.32235 7.56811C4.33283 7.48487 4.33779 7.38179 4.33779 7.25996C4.33779 7.13759 4.33227 7.03505 4.32235 6.95126C4.31078 6.86913 4.29589 6.80187 4.27549 6.75061Z" fill="#2568EF"/></svg></svg><span>{{ translateWord('Seguro, Criptografado') }} {{ translateWord('Pagamentos SSL') }}</span></li>
                        <li class="badge"><svg viewBox="0 0 63 63" aria-hidden="true" focusable="false"><circle cx="31.5" cy="31.5" r="31" fill="#FFF0DF" stroke="#FE8506"/><svg x="8" y="9" width="46" height="46" viewBox="0 0 46 46" fill="none"><path d="M41.0635 20.7209C40.5151 16.3733 38.4172 12.3692 35.1547 9.44366C31.8922 6.51807 27.6841 4.86721 23.3026 4.79406L24.5514 3.55539C24.6418 3.46701 24.7138 3.36162 24.7633 3.24529C24.8128 3.12897 24.8387 3.004 24.8397 2.8776C24.8407 2.75119 24.8166 2.62585 24.7689 2.50878C24.7212 2.39171 24.6509 2.28523 24.5619 2.19547C24.4728 2.10572 24.3669 2.03446 24.2503 1.98581C24.1336 1.93716 24.0085 1.91207 23.8821 1.91199C23.7556 1.91191 23.6305 1.93684 23.5137 1.98535C23.397 2.03385 23.291 2.10497 23.2019 2.19462L20.1663 5.20555C20.077 5.29415 20.0059 5.39948 19.9573 5.51554C19.9086 5.6316 19.8833 5.75611 19.8828 5.88195C19.8823 6.00779 19.9066 6.1325 19.9543 6.24896C20.002 6.36542 20.0721 6.47133 20.1608 6.56066L23.1962 9.62119C23.2846 9.71157 23.39 9.78357 23.5063 9.83304C23.6227 9.88251 23.7476 9.90848 23.874 9.90944C24.0004 9.91041 24.1258 9.88636 24.2429 9.83868C24.3599 9.79099 24.4664 9.72062 24.5562 9.6316C24.6459 9.54259 24.7172 9.4367 24.7658 9.32003C24.8145 9.20336 24.8396 9.07821 24.8396 8.9518C24.8397 8.82539 24.8148 8.70022 24.7663 8.58349C24.7178 8.46675 24.6467 8.36077 24.557 8.27165L23.0092 6.7107C26.3838 6.71306 29.6744 7.76325 32.4265 9.7162C35.1785 11.6691 37.2563 14.4285 38.3727 17.6131C39.4891 20.7976 39.5891 24.2503 38.6588 27.4942C37.7285 30.738 35.814 33.613 33.1795 35.7219C32.9812 35.8809 32.8541 36.1121 32.8263 36.3648C32.8125 36.4899 32.8235 36.6164 32.8587 36.7373C32.8938 36.8581 32.9524 36.9709 33.0312 37.0691C33.1099 37.1673 33.2072 37.249 33.3175 37.3096C33.4278 37.3702 33.5489 37.4085 33.674 37.4223C33.9267 37.4501 34.1801 37.3764 34.3784 37.2174C39.363 33.2202 41.8623 27.0533 41.0635 20.7209Z" fill="#FF8038"/> <path d="M22.8049 36.3787C22.7165 36.2883 22.6111 36.2163 22.4948 36.1669C22.3785 36.1174 22.2535 36.0914 22.1271 36.0904C22.0007 36.0895 21.8753 36.1135 21.7583 36.1612C21.6412 36.2089 21.5347 36.2793 21.445 36.3683C21.3552 36.4573 21.284 36.5632 21.2353 36.6799C21.1867 36.7965 21.1616 36.9217 21.1615 37.0481C21.1614 37.1745 21.1863 37.2997 21.2348 37.4164C21.2833 37.5331 21.3545 37.6391 21.4441 37.7282L22.9919 39.2886C19.6177 39.2865 16.3274 38.2366 13.5754 36.2841C10.8235 34.3316 8.74565 31.5728 7.62896 28.3887C6.51227 25.2046 6.4118 21.7523 7.34143 18.5087C8.27105 15.265 10.1849 12.39 12.8187 10.2808C13.0169 10.1217 13.1439 9.89036 13.1716 9.63766C13.1992 9.38497 13.1254 9.13163 12.9663 8.93337C12.8072 8.73511 12.5759 8.60817 12.3232 8.58048C12.0705 8.55278 11.8172 8.62661 11.6189 8.78571C6.6367 12.7833 4.13886 18.949 4.93766 25.2789C5.48586 29.6266 7.58383 33.6308 10.8465 36.5564C14.1091 39.4819 18.3175 41.1325 22.699 41.2052L21.4497 42.4446C21.3593 42.533 21.2873 42.6384 21.2378 42.7547C21.1884 42.871 21.1624 42.996 21.1614 43.1224C21.1605 43.2488 21.1845 43.3741 21.2322 43.4912C21.2799 43.6083 21.3503 43.7148 21.4393 43.8045C21.5283 43.8943 21.6342 43.9655 21.7508 44.0142C21.8675 44.0628 21.9927 44.0879 22.1191 44.088C22.2455 44.0881 22.3707 44.0631 22.4874 44.0146C22.6041 43.9661 22.7101 43.895 22.7992 43.8054L25.8347 40.7942C25.9241 40.7056 25.9951 40.6002 26.0438 40.4842C26.0924 40.3681 26.1177 40.2436 26.1183 40.1178C26.1188 39.9919 26.0945 39.8672 26.0468 39.7508C25.9991 39.6343 25.929 39.5284 25.8403 39.439L22.8049 36.3787Z" fill="#FF8038"/> <path d="M23.7614 22.2422C23.6252 22.19 23.4975 22.1418 23.3876 22.0934C23.2668 22.04 23.1223 21.9846 22.9627 21.924C22.0553 21.5794 21.5631 21.3071 21.5631 20.8562C21.5631 20.6571 21.7756 20.3481 22.1812 20.1426C22.4687 19.9973 23.5064 19.5993 24.8289 20.5712C24.9302 20.6467 25.0454 20.7014 25.168 20.7322C25.2905 20.7629 25.418 20.7692 25.5429 20.7505C25.6679 20.7318 25.7879 20.6886 25.8961 20.6234C26.0043 20.5581 26.0985 20.4721 26.1734 20.3703C26.2482 20.2685 26.3022 20.1529 26.3322 20.0302C26.3622 19.9075 26.3676 19.78 26.3481 19.6552C26.3287 19.5303 26.2847 19.4106 26.2188 19.3028C26.1529 19.195 26.0663 19.1013 25.964 19.0271C25.3688 18.5833 24.6849 18.2731 23.9589 18.1176V17.25C23.9564 16.9974 23.8544 16.7561 23.675 16.5783C23.4955 16.4006 23.2531 16.3009 23.0006 16.3009C22.748 16.3009 22.5057 16.4006 22.3262 16.5783C22.1467 16.7561 22.0447 16.9974 22.0423 17.25V18.1627C21.7917 18.2278 21.5484 18.3181 21.3161 18.4322C20.2861 18.9533 19.6465 19.8821 19.6465 20.8561C19.6465 22.7148 21.4266 23.391 22.2824 23.716C22.4064 23.7628 22.5197 23.8053 22.6138 23.8469C22.7509 23.9073 22.9085 23.9681 23.0774 24.0327C24.0185 24.3921 24.4382 24.6294 24.4382 25.0839C24.4382 25.2828 24.2257 25.5921 23.8201 25.7971C23.5326 25.9422 22.4953 26.3408 21.1725 25.3684C20.9677 25.2179 20.7115 25.1549 20.4603 25.1933C20.209 25.2316 19.9833 25.3682 19.8328 25.573C19.6822 25.7778 19.6192 26.0339 19.6576 26.2852C19.6959 26.5364 19.8325 26.7621 20.0373 26.9127C20.6322 27.3584 21.3161 27.6708 22.0424 27.8285V28.75C22.0449 29.0025 22.1469 29.2439 22.3264 29.4216C22.5058 29.5994 22.7482 29.6991 23.0008 29.6991C23.2533 29.6991 23.4957 29.5994 23.6751 29.4216C23.8546 29.2439 23.9566 29.0025 23.9591 28.75V27.781C24.2098 27.7146 24.4531 27.623 24.6853 27.5075C25.7153 26.9864 26.3548 26.0579 26.3548 25.0841C26.3547 23.233 24.6678 22.5884 23.7614 22.2422Z" fill="#FF8038"/> <path d="M23.0006 12.4584C20.9157 12.4584 18.8776 13.0766 17.144 14.235C15.4104 15.3933 14.0593 17.0397 13.2614 18.9659C12.4636 20.8921 12.2548 23.0117 12.6615 25.0566C13.0683 27.1015 14.0723 28.9798 15.5466 30.4541C17.0208 31.9283 18.8992 32.9323 20.9441 33.3391C22.9889 33.7458 25.1085 33.5371 27.0347 32.7392C28.961 31.9413 30.6073 30.5902 31.7657 28.8566C32.924 27.1231 33.5423 25.085 33.5423 23C33.5391 20.2052 32.4275 17.5257 30.4512 15.5494C28.4749 13.5732 25.7955 12.4615 23.0006 12.4584ZM23.0006 31.625C21.2948 31.625 19.6272 31.1192 18.2088 30.1714C16.7905 29.2237 15.685 27.8767 15.0322 26.3007C14.3794 24.7246 14.2086 22.9904 14.5414 21.3174C14.8742 19.6443 15.6956 18.1074 16.9018 16.9012C18.1081 15.695 19.6449 14.8735 21.318 14.5407C22.9911 14.2079 24.7253 14.3787 26.3013 15.0315C27.8773 15.6844 29.2243 16.7898 30.1721 18.2082C31.1198 19.6266 31.6256 21.2941 31.6256 23C31.623 25.2867 30.7134 27.4789 29.0965 29.0959C27.4796 30.7128 25.2873 31.6223 23.0006 31.625Z" fill="#FF8038"/></svg></svg><span>{{ translateWord('Garantia de reembolso de 30 dias') }}</span></li>
                    </ul>
                    </div>
                </section>
                <section class="supercharge wrap" aria-label="Supercharge Bundle">
                    <p class="supercharge__lead">{{ translateWord('Já construiu seu site em outro lugar? Obtenha o Builderall em seu site existente gratuitamente!') }}</p>
                    <div class="supercharge__panel">
                        <div>
                            <img class="supercharge__logo" :src="require('@/assets/imagem/supercharge.png')" alt="" width="1080" height="146">
                            <span class="supercharge__bundle">Bundle</span>
                            <p class="supercharge__desc">{{ translateWord('Com apenas uma linha de código adicionada a qualquer site, em qualquer plataforma, você obtém acesso fácil a esse poderoso conjunto de ferramentas.') }}</p>
                        </div>
                        <div class="supercharge__offer">
                            <p class="supercharge__free">{{ translateWord('Grátis') }}</p>
                            <a class="supercharge__cta" :href="superChargeLinkBundlePlan">{{ translateWord('Inscreva-se Agora') }}</a>
                            <p class="supercharge__note">{{ translateWord('Cartão de crédito necessário') }}</p>
                        </div>
                        <div class="supercharge__tools">
                            <h3>{{ translateWord('Ferramentas') }}</h3>
                            <ul>
                                <li>{{ translateWord('Social Proof') }}</li>
                                <li>{{ translateWord('Notificações de Navegador') }}</li>
                                <li>{{ translateWord('Live Chat') }}</li>
                                <li>{{ translateWord('Exit Pop-up') }}</li>
                                <li>{{ translateWord('Meta Autoresponder') }}</li>
                            </ul>
                        </div>
                    </div>
                </section>
                <PricingTestimonials />
                <section class="compare wrap" aria-labelledby="compare-title">
                    <h2 class="display" id="compare-title">{{ translateWord('Compare os recursos dos planos') }}</h2>
                    <table :aria-busy="loading.plans ? 'true' : 'false'">
                        <colgroup>
                            <col class="c-feature">
                            <col v-for="n in compareColCount" :key="'col-' + n">
                        </colgroup>
                        <thead data-hf-pin>
                            <tr>
                                <th scope="col">{{ translateWord('Recursos') }}</th>
                                <template v-if="loading.plans">
                                    <th v-for="n in compareColCount" :key="'skh-' + n" scope="col"><span class="sk"></span></th>
                                </template>
                                <template v-else>
                                    <th v-for="plan in plansFilter" :key="plan.slug" scope="col">{{ plan.title }}</th>
                                </template>
                            </tr>
                        </thead>
                        <tbody v-if="loading.plans">
                            <tr v-for="n in 6" :key="'skr-' + n">
                                <th scope="row"><span class="sk"></span></th>
                                <td v-for="c in compareColCount" :key="'skc-' + n + '-' + c"><span class="sk"></span></td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="(item, row) in resources.items" :key="item.name + '-' + row">
                                <th scope="row">{{ item.name }}</th>
                                <td v-for="(on, col) in item.checks" :key="item.name + '-' + col">
                                    <template v-if="on">
                                        <svg class="yes" aria-hidden="true" viewBox="0 0 16 16"><path d="M15.5 8C15.5 8.64 14.7137 9.1675 14.5562 9.7575C14.3937 10.3675 14.805 11.2175 14.4963 11.7513C14.1825 12.2938 13.2387 12.3588 12.7987 12.7987C12.3588 13.2387 12.2938 14.1825 11.7513 14.4963C11.2175 14.805 10.3675 14.3937 9.7575 14.5562C9.1675 14.7137 8.64 15.5 8 15.5C7.36 15.5 6.8325 14.7137 6.2425 14.5562C5.6325 14.3937 4.7825 14.805 4.24875 14.4963C3.70625 14.1825 3.64125 13.2387 3.20125 12.7987C2.76125 12.3588 1.8175 12.2938 1.50375 11.7513C1.195 11.2175 1.60625 10.3675 1.44375 9.7575C1.28625 9.1675 0.5 8.64 0.5 8C0.5 7.36 1.28625 6.8325 1.44375 6.2425C1.60625 5.6325 1.195 4.7825 1.50375 4.24875C1.8175 3.70625 2.76125 3.64125 3.20125 3.20125C3.64125 2.76125 3.70625 1.8175 4.24875 1.50375C4.7825 1.195 5.6325 1.60625 6.2425 1.44375C6.8325 1.28625 7.36 0.5 8 0.5C8.64 0.5 9.1675 1.28625 9.7575 1.44375C10.3675 1.60625 11.2175 1.195 11.7513 1.50375C12.2938 1.8175 12.3588 2.76125 12.7987 3.20125C13.2387 3.64125 14.1825 3.70625 14.4963 4.24875C14.805 4.7825 14.3937 5.6325 14.5562 6.2425C14.7137 6.8325 15.5 7.36 15.5 8Z" fill="#28BC85"/><path d="M10.1674 5.76438L7.31242 8.61937L5.83242 7.14063C5.51117 6.81938 4.98992 6.81938 4.66867 7.14063C4.34742 7.46188 4.34742 7.98313 4.66867 8.30438L6.74492 10.3806C7.05742 10.6931 7.56492 10.6931 7.87742 10.3806L11.3299 6.92813C11.6512 6.60688 11.6512 6.08562 11.3299 5.76438C11.0087 5.44313 10.4887 5.44313 10.1674 5.76438Z" fill="#FFFCEE"/></svg>
                                        <span class="visually-hidden">{{ translateWord('Incluidos') }}</span>
                                    </template>
                                    <template v-else>
                                        <span class="no" aria-hidden="true"></span>
                                        <span class="visually-hidden">{{ translateWord('Não incluído') }}</span>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </section>
                <section class="faq" aria-labelledby="faq-title">
                    <h2 class="faq__title display" id="faq-title">{{ translateWord('Perguntas frequentes') }}</h2>
                    <div class="faq__list">
                        <div v-for="(question, index) in questions" :key="'faq-' + index" class="faq-item" :class="{ open: openIndex === index }">
                            <button class="faq-q" type="button" :id="'faq-q-' + (index + 1)" :aria-expanded="openIndex === index ? 'true' : 'false'" :aria-controls="'faq-a-' + (index + 1)" @click="toggleFaq(index)">
                                <span>{{ question.text }}</span>
                                <svg class="chev" aria-hidden="true" viewBox="0 0 20 20"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.41107 6.91082C4.08563 7.23626 4.08563 7.7639 4.41107 8.08934L9.41108 13.0893C9.73649 13.4147 10.2642 13.4147 10.5896 13.0893L15.5896 8.08934C15.915 7.7639 15.915 7.23626 15.5896 6.91082C15.2642 6.58539 14.7365 6.58539 14.4111 6.91082L10.0003 11.3216L5.58958 6.91082C5.26414 6.58539 4.73651 6.58539 4.41107 6.91082Z"/></svg>
                            </button>
                            <div class="faq-a" :id="'faq-a-' + (index + 1)" role="region" :aria-labelledby="'faq-q-' + (index + 1)">
                                <div class="faq-a-inner">
                                    <p class="copy" v-html="question.reply"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
        <SiteFooter />
    </div>
</template>


<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import cookie from 'js-cookie';
import Helper from '../assets/js/helper';
import PricingBackdrop from '../components/Pages/PricingBackdrop';
import PricingTestimonials from '../components/Pages/PricingTestimonials';
import SiteHeader from '../components/Pages/SiteHeader';
import SiteFooter from '../components/Pages/SiteFooter';
import PixelAnalytics from '../assets/js/PixelAnalytics';

export default {
    name: "Plans",
    data(){
        return {
            planTypeView: 'normal',
            defaultCountryPrice: 'us',
            loadTranslation: false,
            isUrlPlansTrial: false,
            plans: [],
            plansFilter: [],
            features: [],
            questions: [],
            countryUser: null,
            plansChargeCountry: [],
            countryPrices: [],
            loading: {
                plans: true,
                features: true
            },
            links: {},
            resources: {
                nameTools: [],
                items: []
            },
            superChargeLinkBundlePlan: '',
            recurrencePeriod: 'YEARLY',
            hashAid: '',
            isCountryFallback: false,
            openIndex: null
        }
    },
    async created(){
        if(this.$route.path == '/plans-trial'){
            this.isUrlPlansTrial = true;
        }

        this.planTypeView = this.resolvePlanType();

        await this.verifyTranslation();

        this.pixelPage();

        this.links = this.linksPage('plans');

        PixelAnalytics.createEventPixel('tt', 'ViewPlans', {});

        this.plans = [
            {
                typePlan: 'normal',
                title: 'Core',
                subTitle: this.translateWord('Coloque seu negócio online com o básico que você precisa.'),
                price: 9999,
                symbol: '$',
                includedName: 'All Tools Included',
                slug: 'core-account',
                link: `${Helper.getEnvs().env == 'dev' ? 'http://' : 'https://'}${Helper.getEnvs().urlCheckoutFront}/payment/core-account${this.allParams()}`,
                includes: [
                    '1 User',
                    '1 Publicação Website',
                    '2 Pro Mailboxes',
                    '15 GB Storage'
                ],
                infoComplements: '',
                info: [
                    this.translateWord('Construtor de sites'),
                    this.translateWord('Notificações de Navegador'),
                    this.translateWord('DNS Manager'),
                    this.translateWord('Email Profissional'),
                    this.translateWord('URL Shortener')
                ],
                imageTools: require('../assets/imagem/tool_core.png'),
                tools: ['Teste 1', 'Teste 2'],
                couponSuper: 'SUPER'
            },
            {
                typePlan: 'normal',
                title: 'Essentials',
                subTitle: this.translateWord('Todas as ferramentas que você precisa para começar a expandir seu negócio.'),
                price: 9999,
                symbol: '$',
                includedName: 'All Tools + Templates + Funnels',
                slug: 'essentials-plan',
                link: `${Helper.getEnvs().env == 'dev' ? 'http://' : 'https://'}${Helper.getEnvs().urlCheckoutFront}/payment/essentials-plan${this.allParams()}`,
                includes: [
                    '1 User',
                    '1 Publicação Website',
                    '2 Pro Mailboxes',
                    '15 GB Storage'
                ],
                infoComplements: this.translateWord('Todas as ferramentas Core +'),
                info: [
                    this.translateWord('MaillingBoss'),
                    this.translateWord('Booking'),
                    this.translateWord('Social Proof Pop-Up'),
                    this.translateWord('Sitebot'),
                    this.translateWord('Wordpress')
                ],
                imageTools: require('../assets/imagem/tool_essentials.png'),
                tools: ['Teste 1'],
                couponSuper: 'SUPER1'
            },
            {
                typePlan: 'normal',
                title: 'Advanced',
                subTitle: this.translateWord('Leve seu marketing e vendas para o próximo nível.'),
                price: 9999,
                symbol: '$',
                recommended: true,
                includedName: 'Builderall Builder + Mailingboss',
                slug: 'advanced-plan',
                link: `${Helper.getEnvs().env == 'dev' ? 'http://' : 'https://'}${Helper.getEnvs().urlCheckoutFront}/payment/advanced-plan${this.allParams()}`,
                includes: [
                    '1 User',
                    '1 Publicação Website',
                    '2 Pro Mailboxes',
                    '15 GB Storage'
                ],
                infoComplements: this.translateWord('Todas as ferramentas Essential +'),
                info: [
                    this.translateWord('Construtor de Funis'),
                    this.translateWord('Central de WhatsApp'),
                    this.translateWord('Mensagens SMS'),
                    this.translateWord('IG/Messenger Chatbot'),
                    this.translateWord('CRM'),
                    this.translateWord('eLearning'),
                    this.translateWord('Team Access')
                ],
                imageTools: require('../assets/imagem/tool_advanced.png'),
                tools: ['Teste 1', 'Teste 2', 'Teste 3'],
                couponSuper: 'SUPER2'
            },
            {
                typePlan: 'normal',
                title: 'Premium',
                subTitle: this.translateWord('Tudo que você precisa para lançar e expandir seu negócio.'),
                price: 9999,
                symbol: '$',
                includedName: 'All Tools Included',
                slug: 'premium-plus-plan',
                link: `${Helper.getEnvs().env == 'dev' ? 'http://' : 'https://'}${Helper.getEnvs().urlCheckoutFront}/payment/premium-plus-plan${this.allParams()}`,
                includes: [
                    '1 User',
                    '1 Publicação Website',
                    '2 Pro Mailboxes',
                    '15 GB Storage'
                ],
                infoComplements: this.translateWord('Todas as ferramentas Advanced +'),
                info: [
                    this.translateWord('Video Hosting'),
                    this.translateWord('Webinar Builder'),
                    this.translateWord('Quiz Builder'),
                    this.translateWord('Builderall Plume')
                ],
                imageTools: require('../assets/imagem/tool_premium.png'),
                tools: ['Teste 1', 'Teste 2'],
                couponSuper: 'SUPER3'
            },
            {
                typePlan: 'wordpress',
                title: 'WP Premium',
                subTitle: this.translateWord('Tudo que você precisa para lançar e expandir seu negócio.'),
                price: 9999,
                symbol: '$',
                includedName: 'All Tools Included',
                slug: 'wp-premium-plus-plan',
                link: `${Helper.getEnvs().env == 'dev' ? 'http://' : 'https://'}${Helper.getEnvs().urlCheckoutFront}/payment/wp-premium-plus-plan${this.allParams()}`,
                includes: [
                    '1 User',
                    '1 Publicação Website',
                    '2 Pro Mailboxes',
                    '15 GB Storage'
                ],
                info: [
                    this.translateWord('Criador de Conteúdo IA'),
                    this.translateWord('Advanced, mais:'),
                    this.translateWord('Criador do curso'),
                    this.translateWord('Hospedagem de vídeo')
                ],
                imageTools: require('../assets/imagem/tool_premium.png'),
                couponSuper: 'SUPER3'
            },
            {
                typePlan: 'wordpress',
                title: 'WP Advanced',
                subTitle: this.translateWord('Leve seu marketing e vendas para o próximo nível.'),
                price: 9999,
                symbol: '$',
                recommended: true,
                includedName: 'Builderall Builder + Mailingboss',
                slug: 'wp-advanced-plan',
                link: `${Helper.getEnvs().env == 'dev' ? 'http://' : 'https://'}${Helper.getEnvs().urlCheckoutFront}/payment/wp-advanced-plan${this.allParams()}`,
                includes: [
                    '1 User',
                    '1 Publicação Website',
                    '2 Pro Mailboxes',
                    '15 GB Storage'
                ],
                info: [
                    this.translateWord('Criador de Conteúdo IA'),
                    this.translateWord('Essentials, mais:'),
                    this.translateWord('Construtor de funil'),
                    this.translateWord('Todas as ferramentas de lançamento')
                ],
                imageTools: require('../assets/imagem/tool_advanced.png'),
                couponSuper: 'SUPER2'
            },
            {
                typePlan: 'wordpress',
                title: 'WP Essentials',
                subTitle: this.translateWord('Todas as ferramentas que você precisa para começar a expandir seu negócio.'),
                price: 9999,
                symbol: '$',
                includedName: 'All Tools + Templates + Funnels',
                slug: 'wp-essentials-plan',
                link: `${Helper.getEnvs().env == 'dev' ? 'http://' : 'https://'}${Helper.getEnvs().urlCheckoutFront}/payment/wp-essentials-plan${this.allParams()}`,
                includes: [
                    '1 User',
                    '1 Publicação Website',
                    '2 Pro Mailboxes',
                    '15 GB Storage'
                ],
                info: [
                    this.translateWord('Criador de Conteúdo IA'),
                    this.translateWord('Construtor de sites'),
                    this.translateWord('Automação de e-mail'),
                    this.translateWord('Bate-papo no site')
                ],
                imageTools: require('../assets/imagem/tool_essentials.png'),
                couponSuper: 'SUPER1'
            }
        ];

        if(this.isUrlPlansTrial){
            this.plans = [
                {
                    typePlan: 'trial',
                    title: 'Premium',
                    subTitle: this.translateWord('Tudo que você precisa para lançar e expandir seu negócio.'),
                    price: 9999,
                    symbol: '$',
                    includedName: 'All Tools Included',
                    slug: 'premium-plus-plan-trial',
                    link: `${Helper.getEnvs().env == 'dev' ? 'http://' : 'https://'}${Helper.getEnvs().urlCheckoutFront}/payment/premium-plus-plan-trial${this.allParams()}`,
                    includes: [
                        '1 User',
                        '1 Publicação Website',
                        '2 Pro Mailboxes',
                        '15 GB Storage'
                    ],
                    info: [
                        this.translateWord('Criador de Conteúdo IA'),
                        this.translateWord('Advanced, mais:'),
                        this.translateWord('Criador do curso'),
                        this.translateWord('Hospedagem de vídeo')
                    ],
                    imageTools: require('../assets/imagem/tool_premium.png'),
                    tools: ['Teste 1', 'Teste 2']
                },
                {
                    typePlan: 'trial',
                    title: 'Advanced',
                    subTitle: this.translateWord('Leve seu marketing e vendas para o próximo nível.'),
                    price: 9999,
                    symbol: '$',
                    recommended: true,
                    includedName: 'Builderall Builder + Mailingboss',
                    slug: 'advanced-plan-trial',
                    link: `${Helper.getEnvs().env == 'dev' ? 'http://' : 'https://'}${Helper.getEnvs().urlCheckoutFront}/payment/advanced-plan-trial${this.allParams()}`,
                    includes: [
                        '1 User',
                        '1 Publicação Website',
                        '2 Pro Mailboxes',
                        '15 GB Storage'
                    ],
                    info: [
                        this.translateWord('Criador de Conteúdo IA'),
                        this.translateWord('Essentials, mais:'),
                        this.translateWord('Construtor de funil'),
                        this.translateWord('Todas as ferramentas de lançamento')
                    ],
                    imageTools: require('../assets/imagem/tool_advanced.png'),
                    tools: ['Teste 1', 'Teste 2', 'Teste 3']
                },
                {
                    typePlan: 'trial',
                    title: 'Essentials',
                    subTitle: this.translateWord('Todas as ferramentas que você precisa para começar a expandir seu negócio.'),
                    price: 9999,
                    symbol: '$',
                    includedName: 'All Tools + Templates + Funnels',
                    slug: 'essentials-plan-trial',
                    link: `${Helper.getEnvs().env == 'dev' ? 'http://' : 'https://'}${Helper.getEnvs().urlCheckoutFront}/payment/essentials-plan-trial${this.allParams()}`,
                    includes: [
                        '1 User',
                        '1 Publicação Website',
                        '2 Pro Mailboxes',
                        '15 GB Storage'
                    ],
                    info: [
                        this.translateWord('Criador de Conteúdo IA'),
                        this.translateWord('Construtor de sites'),
                        this.translateWord('Automação de e-mail'),
                        this.translateWord('Bate-papo no site')
                    ],
                    imageTools: require('../assets/imagem/tool_essentials.png'),
                    tools: ['Teste 1']
                },
                {
                    typePlan: 'trial',
                    title: 'Core',
                    subTitle: this.translateWord('Coloque seu negócio online com o básico que você precisa.'),
                    price: 9999,
                    symbol: '$',
                    includedName: 'All Tools + Templates + Funnels',
                    slug: 'core-account-trial',
                    link: `${Helper.getEnvs().env == 'dev' ? 'http://' : 'https://'}${Helper.getEnvs().urlCheckoutFront}/payment/core-account-trial${this.allParams()}`,
                    includes: [
                        '1 User',
                        '1 Publicação Website',
                        '2 Pro Mailboxes',
                        '15 GB Storage'
                    ],
                    info: [
                        this.translateWord('Criador de Conteúdo IA'),
                        this.translateWord('Construtor de sites')
                    ],
                    imageTools: require('../assets/imagem/tool_core.png'),
                    tools: ['Teste 1']
                }
            ];
        }

        this.changePlanType(this.planTypeView);

        await this.listCountryPrice();
        
        await Promise.all(this.plans.map(async plan => {
            let planCharge = this.countryPrices.find(planCharge => planCharge.plan.slug == plan.slug);

            if(planCharge == undefined) return;

            plan.id = planCharge.plan.id;
            plan.price = parseFloat(planCharge.currency.value) * 100;
            plan.symbol = planCharge.currency.symbol;
            plan.currency = planCharge.currency.name;
            plan.tools = planCharge.plan.tools.filter(tool => !['WhatsApp Launch Manager', 'BuilderallZap'].includes(tool));
            plan.isCoupon = false;
            plan.coupon = {};

            plan.monthly = {
                amount: plan.price,
            };

            if(planCharge.plan.value_annual > 0){
                plan.annual = {
                    amount: planCharge.plan.value_annual * 100,
                    amountRef: planCharge.plan.ref_value_annual,
                    monthAmount: planCharge.plan.value_month,
                    monthAmountRef: planCharge.plan.ref_value_month
                }
            }

            let couponCodeUrl = this.$route.query.coupon !== undefined ? this.$route.query.coupon : false;

            if(couponCodeUrl){
                couponCodeUrl = couponCodeUrl.toUpperCase();

                if(['SUPER', 'SUPER1', 'SUPER2', 'SUPER3'].includes(couponCodeUrl)){
                    let hasCouponSuper = Helper.getNewNameCouponSuper(plan.couponSuper, plan.slug);

                    if(hasCouponSuper.hasNewNameCoupon) couponCodeUrl = hasCouponSuper.newCoupon;
                }

                await this.validateCoupon({
                    couponUser: couponCodeUrl, 
                    isLoadingCheckout: true,
                    isPagePlan: true,
                    planId: plan.id,
                    couponPeriod: 'MENSAL'
                });

                if(this.coupon.isValid){
                    plan.isCoupon = true;
                    plan.isValidMonth = true;
                    let amountCoupon = Helper.calcDiscount(plan.price / 100, this.coupon.value, this.coupon.type) * 100;
                    
                    plan.coupon.amount = amountCoupon;
                    plan.coupon.amountApplied = plan.price - amountCoupon;
                    plan.coupon.period = this.coupon.period;
                    plan.coupon.periodTime = this.coupon.periodTime;

                    this.clearCoupon();
                }

                await this.validateCoupon({
                    couponUser: couponCodeUrl, 
                    isLoadingCheckout: true,
                    isPagePlan: true,
                    planId: plan.id,
                    couponPeriod: 'ANUAL'
                });

                if(this.coupon.isValid){
                    plan.isCoupon = true;
                    plan.isValidAnnual = true;

                    let amountCoupon = Helper.calcDiscount(planCharge.plan.value_annual, this.coupon.value, this.coupon.type) * 100;
                    // let amountCouponAnnual = null;

                    // if(planCharge.plan.value_annual > 0){
                    //     plan.coupon.amountAnnual = Helper.calcDiscount(planCharge.plan.value_annual, this.coupon.value, this.coupon.type) * 100;
                    //     plan.coupon.amountAnnualApplied = planCharge.plan.value_annual - amountCouponAnnual;
                    // }
                    
                    plan.coupon.amountAnnual = amountCoupon;
                    plan.coupon.amountAnnualApplied = planCharge.plan.value_annual - amountCoupon;
                    plan.coupon.period = this.coupon.period;
                    plan.coupon.periodTime = this.coupon.periodTime;

                    this.clearCoupon();
                }
            }

            if(planCharge.plan.front_resource_items){
                let includesInfo = Object.values(planCharge.plan.front_resource_items);

                //Adicionar os check(fake) false para ultimo e remove o recurso de domains
                includesInfo.forEach((v, i) => {
                    if(v.fake) {
                        let item = includesInfo.splice(i, 1);
                        includesInfo.push(item[0]);
                    }
                });

                let toolsValid = [];
                let toolsFake = [];

                includesInfo.forEach(tool => {
                    if(tool.fake){
                        toolsFake.push(tool);
                    }else{
                        toolsValid.push(tool);
                    }
                });

                includesInfo = [...toolsValid, ...toolsFake];

                plan.includes = [];
                includesInfo.forEach(included => {
                    if(['domains', 'storage', 'subdomains', 'subscribers_plan'].includes(included.resource)) return;

                    let qtd = Helper.convertNumber(included.quantity);

                    if(included.quantity == 0) qtd = '';

                    if(included.quantity == 999999) qtd = this.translateWord('Ilimitado');

                    plan.includes.push({
                        name: `${qtd} ${included.title}`,
                        check: !included.fake,
                        type: null
                    });

                    // Adiciona "Additional up to 5000" abaixo de subscribers
                    if(included.resource === 'subscribers' && !included.fake) {
                        plan.includes.push({
                            name: `- ${this.translateWord('Adicional de US$ 10 por cada 5.000')}`,
                            check: true,
                            type: 'additionalSubscribers'
                        });
                    }
                });

                if(plan.slug != 'core-account'){
                    let middleItems = plan.includes.splice(5, 2);

                    if(plan.slug.search('premium') !== -1){
                        middleItems.unshift(
                            {
                                name: this.translateWord('Suporte VIP Dedicado'),
                                check: true
                            },
                            {
                                name: this.translateWord('Serviço de Migração Gratuito*'),
                                check: true
                            }
                        )
                    }

                    plan.includes = [...middleItems, ...plan.includes];
                }
                
            }

            return plan;
        })); 
        
        if(this.$route.query['period'] === 'm'){ 
            this.changePeriodCharge('MONTHLY');
        } else {
            this.changePeriodCharge('YEARLY');
        }

        this.questions = [
            {
                text: this.translateWord('Existe a possibilidade de adicionar produtos ou fazer upgrades?'),
                reply: this.translateWord('Sim! Nós temos opções adicionais e upgrades disponíveis exclusivos para potencializar seu negócio.'),
                visible: true
            },
            {
                text: this.translateWord('É possível importar meu conteúdo para a plataforma?'),
                reply: this.translateWord('Como a nossa plataforma possuí uma arquitetura exclusiva e única para maximizar performance e carregamento de nossos websites, arquivos externos não são compatíveis com o nosso sistema. Para nossos novos membros que estão migrando para a Builderall, disponibilizamos diversos templates para criar seu website com facilidade.'),
                visible: true
            },
            {
                text: this.translateWord('Quando posso fazer um upgrade do meu plano?'),
                reply: this.translateWord('Você pode realizar um upgrade do seu plano a qualquer momento, basta contactar nosso time de suporte através do chat online ou via ticket!'),
                visible: true
            },
            {
                text: this.translateWord('O que acontece se eu exceder meu limite de email ou armazenamento?'),
                reply: this.translateWord('Notificaremos você antes de atingir seu limite. Você pode fazer upgrade do seu plano ou comprar um add-on — não cortaremos seu serviço sem aviso.'),
                visible: true
            },
            {
                text: this.translateWord('Existe teste gratuito?'),
                reply: this.translateWord('Todos os planos vêm com garantia de devolução do dinheiro em 30 dias. Experimente qualquer plano sem riscos e receba reembolso total se não for adequado.'),
                visible: true
            },
            {
                text: this.translateWord('Posso cancelar a qualquer momento?'),
                reply: this.translateWord('Sim. Planos mensais podem ser cancelados antes da próxima data de cobrança sem penalidade. Planos anuais são reembolsáveis nos primeiros 30 dias.'),
                visible: true
            },
            {
                text: this.translateWord('Vocês oferecem descontos para agências ou revendedores?'),
                reply: this.translateWord('Sim — temos um programa de parceiros e agências. Visite a página de <a href="{0}" target="_blank" rel="noopener">Parceiros</a> ou entre em contato com nosso time para saber sobre preços por volume e revenda.', [`${this.links.affiliate}${this.allParams()}`]),
                visible: true
            }
        ];

        this.changePlanType(this.planTypeView);
        this.loading.plans = false;

        //Sort the display of plans in ascending order. Only for trial plans
        this.plans.sort((a, b) => a.price - b.price);

        this.superChargeLinkBundlePlan = `${Helper.getEnvs().env == 'dev' ? 'http://' : 'https://'}${Helper.getEnvs().urlCheckoutFront}/payment/bundle-plan${this.allParams()}`;
        this.loading.features = false;
    },
    
    computed: {
        ...mapState([
            'localeUser',
            'endpointOffice',
            'coupon'
        ]),
        ...mapGetters([
            'translateWord',
            'getAllParamsUrl',
            'detectReferrer',
            'linksPage'
        ]),
        priceFit(){
            let symLen = 1;
            let amtLen = 1;

            this.plansFilter.forEach(plan => {
                let sym = this.displaySymbol(plan) || '';
                let amount = `${this.amountSplit(plan.price)}.${this.amountSplit(plan.price, true)}`;

                if(sym.length > symLen) symLen = sym.length;
                if(amount.length > amtLen) amtLen = amount.length;
            });

            return {
                '--sym-len': symLen,
                '--amt-len': amtLen
            };
        },
        billingCurrency(){
            let plan = this.plansFilter.find(plan => plan.currency);
            return plan ? plan.currency : 'USD';
        },
        showBrlPay(){
            return this.plansFilter.some(plan => plan.currency === 'BRL');
        },
        compareColCount(){
            if(this.loading.plans) return this.planTypeView == 'wp' ? 3 : 4;
            return this.plansFilter.length;
        }
    },
    methods: {
        ...mapActions([
            'getTranslation',
            'getCountryPrices',
            'verifyPixelAnalytics',
            'verifyPixelBuilderall',
            'verifyPixelAnalyticsParent',
            'validateCoupon'
        ]),
        ...mapMutations([
            'enabledFullScreenLoading',
            'clearCoupon'
        ]),
        async listCountryPrice(){
            this.isCountryFallback = false;
            this.countryPrices = await this.getCountryPrices(this.$route.query['country'] || null);

            for(let plan of this.plans){
                let planCharge = this.countryPrices.find(planCharge => planCharge.plan.slug == plan.slug);

                if(planCharge == undefined){
                    this.isCountryFallback = true;
                    this.countryPrices = await this.getCountryPrices(this.defaultCountryPrice);
                    return;
                }
            }
        },
        resolvePlanType(){
            if(this.$route.path == '/plans-trial') return 'trial';
            if(this.$route.query.type === 'wp') return 'wp';
            return 'normal';
        },
        displaySymbol(plan){
            let country = ((this.localeUser && this.localeUser.country) || '').toString().toUpperCase();
            let queryCountry = (this.$route.query.country || '').toString().toUpperCase();

            if(plan.currency === 'USD' && queryCountry && queryCountry !== 'US' && country && country !== 'US' && !this.isCountryFallback){
                return 'USD $';
            }

            return plan.symbol;
        },
        wordpressHref(){
            return `https://builderall.com/wordpress${this.allParams()}`;
        },
        allPlansHref(){
            let params = this.getAllParamsUrl(false);
            let searchParams = new URLSearchParams(params);

            searchParams.delete('period');
            searchParams.delete('type');

            params = searchParams.toString();

            return params ? `/plans?${params}` : '/plans';
        },
        planCheckoutHref(plan){
            let period = this.recurrencePeriod == 'YEARLY' ? 'period=y' : 'period=m';
            let join = plan.link.includes('?') ? '&' : '?';

            return `${plan.link}${join}${period}${this.hashAid}`;
        },
        onPlanCta(event){
            if(this.loading.plans) event.preventDefault();
        },
        toggleFaq(index){
            this.openIndex = this.openIndex === index ? null : index;
        },
        allParams() {
            let params = this.getAllParamsUrl(false);
            let searchParams = new URLSearchParams(params);

            searchParams.delete('period');
            
            params = searchParams.toString();

            // Adicionar #aid quando houver
            if (Helper.getParamHash('aid')) {
                this.hashAid = `#aid=${Helper.getParamHash('aid')}`;
            }

            return params ? `?${params}` : '';
        },
        amountSplit(amount, isDecimal){
            let amountFormat = (amount / 100).toFixed(2);

            return isDecimal ? amountFormat.split('.')[1] : amountFormat.split('.')[0];

        },
        changePlanType(type){
            this.planTypeView = type;

            if(this.planTypeView == 'normal') this.mountRecourses('normal');

            if(this.planTypeView == 'trial') this.mountRecourses('trial');

            if(this.planTypeView == 'wp') this.mountRecourses('wordpress');
        },
        async verifyTranslation(){
            let lang = Helper.convertSigla(Helper.getLangBrowser());

            //Temporario ate traduzir o polones
            lang = lang == 'pl' ? 'en' : lang;

            await this.getTranslation({
                sigla: lang,
                category: 'plans'
            });

            this.loadTranslation = true;
        },
        mountRecourses(planType){
            this.createResources(planType);
            
            for(let i = 1; i <= this.plansFilter.length; i++){
                this.verifyAccessTool(this.plansFilter[i - 1].tools, i);
            }

            this.tempOrderList();
        },
        createResources(planType){
            this.plansFilter = this.plans.filter(plan => plan.typePlan == planType);

            //Sort the display of plans in ascending order. Only for trial plans
            this.plansFilter.sort((a, b) => a.price - b.price);

            let tools = [];
            let titles = [];

            this.plansFilter.map(plan => tools.push(...(plan.tools || [])));
            this.plansFilter.map(plan => titles.push(plan.title));

            this.resources.nameTools = titles;
            this.resources.items = tools.filter((name, index, arr) => arr.indexOf(name) === index).map(name => ({
                name: name,
                checks: this.plansFilter.map(r => false) //Marcar todas como false para iniciar o resources
            }));

            // //Adiciona feature se selecionar para exibir plano wordpress
            if(this.planTypeView == 'wp') {
                this.resources.items.unshift({name: this.translateWord('Servidor em nuvem (Wordpres & WooCommerce)'), checks: [true, true, true]})
            }
        },
        verifyAccessTool(toolsCheck, indiceCheck){
            indiceCheck = --indiceCheck;

            (toolsCheck || []).forEach(nameUrl => {
                this.resources.items.forEach((nameResource, index) => {
                    if(nameUrl == nameResource.name){
                        this.resources.items[index].checks[indiceCheck] = true
                    }
                })
            });
        },
        tempOrderList(){
            let list = JSON.parse(JSON.stringify(this.resources.items));
            let newList = [];

            list.forEach(item => {
                let totalTrue = 4;
                let totalFound = 0;

                item.checks.forEach(value => value ? totalFound++ : '')

                if(totalFound == totalTrue) newList.push(item);
            });

            list.forEach(item => {
                let totalTrue = 3;
                let totalFound = 0;

                item.checks.forEach(value => value ? totalFound++ : '')

                if(totalFound == totalTrue) newList.push(item);
            });

            list.forEach(item => {
                let totalTrue = 2;
                let totalFound = 0;

                item.checks.forEach(value => value ? totalFound++ : '')

                if(totalFound == totalTrue) newList.push(item);
            });

            list.forEach(item => {
                let totalTrue = 1;
                let totalFound = 0;

                item.checks.forEach(value => value ? totalFound++ : '')

                if(totalFound == totalTrue) newList.push(item);
            });

            this.resources.items = newList;
        },
        pixelPage(){
            let aid = Helper.getAidOffice() || this.$route.query.aid || cookie.get('IdPaiOffice') || Helper.builderallAccounts.internetMarketingLLC_10;
            let subdomain = this.$route.query.sd || null;

            if(subdomain === null) {
                let urlWithHash = new URLSearchParams(decodeURIComponent(location.hash.replace('#', '')));

                if(urlWithHash.get('sd')) subdomain = urlWithHash.get('sd');
            }

            this.$route.query['pixel-event'] ? this.verifyPixelAnalyticsParent() : this.verifyPixelAnalytics({aid, subdomain});

            this.verifyPixelBuilderall();

        },
        changePeriodCharge(period){            
            this.changePeriodRecurring(period == 'MONTHLY' ? 'MONTHLY' : 'YEARLY');

            this.recurrencePeriod = period;

            if(this.plans.length) this.changePlanType(this.planTypeView);
        },
        changePeriodRecurring(period){
            this.plans = this.plans.map(plan => {
                return {
                    ...plan,
                    price: period == 'YEARLY' ? plan.annual.monthAmount*100 : plan.monthly.amount,
                }
            });
        },
        //Configuracao das features novas exibidas nos cards redesenhados (toolkit, builder, email)
        //Mapeado por slug do plano. WP plans usam o mesmo mapping do plano base (sem prefixo wp-)
        getCardFeatures(plan){
            let slug = plan.slug.replace(/^wp-/, '').replace(/-trial$/, '');
            let configs = {
                'core-account': {
                    toolkit: [
                        { label: this.translateWord('Domínio gratuito por 1 ano') },
                        { label: this.translateWord('Caixas de email Pro (@seudominio)'), value: '1', color: 'blue' },
                        { label: this.translateWord('Espaço em disco'), value: '2 GB', color: 'blue' },
                        { label: this.translateWord('Créditos Builderall AI'), value: '250', color: 'orange' }
                    ],
                    builder: [
                        { label: this.translateWord('Website(s) Publicado(s)'), value: '1', color: 'orange' },
                        { label: this.translateWord('Ferramentas Supercharge Marketing') }
                    ],
                    email: []
                },
                'essentials-plan': {
                    toolkit: [
                        { label: this.translateWord('Domínio gratuito por 1 ano') },
                        { label: this.translateWord('Caixas de email Pro (@seudominio)'), value: '3', color: 'blue' },
                        { label: this.translateWord('Espaço em disco'), value: '10 GB', color: 'blue' },
                        { label: this.translateWord('Créditos Builderall AI'), value: '500', color: 'orange' }
                    ],
                    builder: [
                        { label: this.translateWord('Website(s) Publicado(s)'), value: '10', color: 'orange' },
                        { label: this.translateWord('Ferramentas Supercharge Marketing') },
                        { label: this.translateWord('Ecommerce & Pagamentos') }
                    ],
                    email: [
                        { label: this.translateWord('Emails enviados/mês'), value: '60k', color: 'green' },
                        { label: this.translateWord('Assinantes'), value: '3,000', color: 'green' }
                    ]
                },
                'advanced-plan': {
                    toolkit: [
                        { label: this.translateWord('Domínio gratuito por 1 ano') },
                        { label: this.translateWord('Caixas de email Pro (@seudominio)'), value: '10', color: 'blue' },
                        { label: this.translateWord('Espaço em disco'), value: '30 GB', color: 'blue' },
                        { label: this.translateWord('Créditos Builderall AI'), value: '1500', color: 'orange' },
                        { label: this.translateWord('Contas de Time'), value: '3', color: 'orange' }
                    ],
                    builder: [
                        { label: this.translateWord('Website(s) Publicado(s)'), value: '25', color: 'orange' },
                        { label: this.translateWord('Ferramentas Supercharge Marketing') },
                        { label: this.translateWord('Ecommerce & Pagamentos') }
                    ],
                    email: [
                        { label: this.translateWord('Emails enviados/mês'), value: '250k', color: 'green' },
                        { label: this.translateWord('Assinantes'), value: '10,000', color: 'green' }
                    ]
                },
                'premium-plus-plan': {
                    toolkit: [
                        { label: this.translateWord('Domínio gratuito por 1 ano') },
                        { label: this.translateWord('Caixas de email Pro (@seudominio)'), value: '25', color: 'blue' },
                        { label: this.translateWord('Espaço em disco'), value: '75 GB', color: 'blue' },
                        { label: this.translateWord('Créditos Builderall AI'), value: '3000', color: 'orange' },
                        { label: this.translateWord('Contas de Time'), value: '10', color: 'orange' }
                    ],
                    builder: [
                        { label: this.translateWord('Website(s) Publicado(s)'), value: '25', color: 'orange' },
                        { label: this.translateWord('Ferramentas Supercharge Marketing') },
                        { label: this.translateWord('Ecommerce & Pagamentos') }
                    ],
                    email: [
                        { label: this.translateWord('Emails enviados/mês'), value: '1M', color: 'green' },
                        { label: this.translateWord('Assinantes'), value: '100,000', color: 'green' }
                    ]
                }
            };
            return configs[slug] || configs['core-account'];
        },
    },
    components: {
        PricingBackdrop,
        PricingTestimonials,
        SiteHeader,
        SiteFooter
    }
}
</script>

<style lang="scss" src="@/scss/plans/index.scss"></style>
